const extraOptions = [
  {
    "model": "spare-wheel",
    "price": 110,
    "img": "images/extra-options-2025/Spare wheel.jpg",
    "imgAlt": "spare-wheel",
    "multilingualName": true,
    "isSquareImage": true
  },
  {
    "model": "support-leg",
    "price": 50,
    "img": "images/extra-options-2025/Lifting legs 1300kg.jpg",
    "imgAlt": "support-leg",
    "multilingualName": true,
    "isSquareImage": true
  },
  {
    "model": "quick-lock-system",
    "price": 35,
    "img": "images/extra-options-2025/Quick Lock System.jpg",
    "imgAlt": "quick-lock-system",
    "multilingualName": true,
    "isSquareImage": true
  },
  {
    "model": "heavy-duty-leg",
    "price": 600,
    "img": "images/extra-options-2025/Heavy Duty Legs 3000kg.jpg",
    "imgAlt": "heavy-duty-leg",
    "multilingualName": true,
    "isSquareImage": true
  },
  {
    "model": "stabilizier-triangle",
    "price": 30,
    "img": "images/extra-options-2025/Stabilizer triangle.jpg",
    "imgAlt": "stabilizier-triangle",
    "multilingualName": true,
    "isSquareImage": true
  },
  {
    "model": "jockey-wheel",
    "price": 50,
    "img": "images/extra-options-2025/Jockey Wheel2.jpg",
    "imgAlt": "jockey-wheel",
    "multilingualName": true,
    "isSquareImage": true
  },
];


export default extraOptions;
